import { Component } from 'react'

class RefetchOnLocaleChange extends Component {

  componentWillUpdate(nextProps) {
    if (nextProps.locale !== this.props.locale) {
      this.props.refetch()
    }
  }

  render() {
    return this.props.children
  }
}

export default RefetchOnLocaleChange;


// WEBPACK FOOTER //
// ./src/utils/RefetchOnLocaleChange.js